import Badge from "@/v2-backoffice-client/components/badge"

export type LicenseFeatureGroupReachMarkProps = {
  reaches: boolean
  userName?: string
  /** The symbol alone, name in the tooltip: for a header row with no room. */
  compact?: boolean
}

// "Check as a user" on a row: whether the entitlement rule, run for the
// picked user, actually grants this item — seats and the customer's closed
// classes included. Ground truth beside the draft, so an
// operator sees the effect of what is ticked on one real person.
function LicenseFeatureGroupReachMark(
  props: LicenseFeatureGroupReachMarkProps,
) {
  const { reaches, userName, compact = false } = props
  const who = userName ?? "the user"
  const symbol = reaches ? "✓" : "✗"
  return (
    <Badge
      size="xs"
      variant={reaches ? "positive" : "critical"}
      className="max-w-32 shrink-0 truncate"
      title={reaches ? `Reaches ${who}` : `Does not reach ${who}`}
    >
      {compact ? symbol : `${symbol} ${who}`}
    </Badge>
  )
}

export default LicenseFeatureGroupReachMark
